import { faAngleDown, faAngleUp } from '@fortawesome/pro-regular-svg-icons';
import cx from 'classnames';
import { prams } from 'mk/autogenerated/bzProps/prams';
import { STROLLER_BRANDS } from 'mk/autogenerated/strollersData';
import {
    BZ2_FACET_P_COLOR,
    STROLLER_FEATURE_AVAILABILITY,
    STROLLER_FEATURE_AVAILABILITY_ALL,
    STROLLER_FEATURE_AVAILABILITY_AVAILABLE,
    STROLLER_FEATURE_AVAILABILITY_ONLY_NEW,
    STROLLER_FEATURE_AVAILABILITY_ONLY_OLD,
    STROLLER_FEATURE_BACK_SUPPORT_CAN_BE_IN_LYING_POSITION,
    STROLLER_FEATURE_NUMBER_OF_KIDS,
    STROLLER_FEATURE_NUMBER_OF_WHEELS_L,
    STROLLER_FEATURE_ON_MARKET_FROM_MAX,
    STROLLER_FEATURE_ON_MARKET_FROM_MIN,
    STROLLER_FEATURE_PRICE,
    STROLLER_FEATURE_PRICE_RANGE_1,
    STROLLER_FEATURE_PRICE_RANGE_2,
    STROLLER_FEATURE_PRICE_RANGE_3,
    STROLLER_FEATURE_PRICE_RANGE_4,
    STROLLER_FEATURE_PRICE_RANGE_5,
    STROLLER_FEATURE_PRICE_RANGE_6,
    STROLLER_FEATURE_PRICE_RANGE_from_to,
    STROLLER_FEATURE_REAR_WHEELS_DIAMETER,
    STROLLER_FEATURE_REAR_WHEELS_DIAMETER_BIG,
    STROLLER_FEATURE_REAR_WHEELS_DIAMETER_MEDIUM,
    STROLLER_FEATURE_REAR_WHEELS_DIAMETER_SMALL,
    STROLLER_FEATURE_RECOMMENDED_AGE,
    STROLLER_FEATURE_RECOMMENDED_AGE_MORE_MONTHS,
    STROLLER_FEATURE_ROTATING_FIXATION_WHEELS,
    STROLLER_FEATURE_SIBLINGS_TYPE,
    STROLLER_FEATURE_STROLLER_FOR_PARENT_BY_HEIGHT,
    STROLLER_FEATURE_TYPE,
    STROLLER_FEATURE_TYPE_2KOMBI,
    STROLLER_FEATURE_WEIGHT_IN_KG_MAX,
    STROLLER_FEATURE_WEIGHT_IN_KG_MIN,
    STROLLER_FEATURE_WHEEL_TYPE_SEARCH,
    STROLLER_SEARCH_FORM_ADJUSTABLE_HANDLE,
    STROLLER_SEARCH_FORM_BACK_SUPPORT_CAN_BE_POSITIONED,
    STROLLER_SEARCH_FORM_BIG_SHOPPING_BASKET,
    STROLLER_SEARCH_FORM_BUMPER_BAR,
    STROLLER_SEARCH_FORM_CAR_SEAT_CAN_BE_ATTACHED,
    STROLLER_SEARCH_FORM_CARRYCOT_HAS_HANDLE,
    STROLLER_SEARCH_FORM_FOLDABLE_CARRYCOT,
    STROLLER_SEARCH_FORM_FOLDABLE_HANDRAIL,
    STROLLER_SEARCH_FORM_HARNESS_TYPE_5B,
    STROLLER_SEARCH_FORM_LEG_REST_CAN_BE_POSITIONED,
    STROLLER_SEARCH_FORM_MANUAL_BRAKE_PRESENT,
    STROLLER_SEARCH_FORM_MAXIMUM_LOAD_PER_CHILD_IN_KG,
    STROLLER_SEARCH_FORM_MAXIMUM_LOAD_PER_CHILD_IN_KG_RANGE_1,
    STROLLER_SEARCH_FORM_MAXIMUM_LOAD_PER_CHILD_IN_KG_RANGE_2,
    STROLLER_SEARCH_FORM_MAXIMUM_LOAD_PER_CHILD_IN_KG_RANGE_3,
    STROLLER_SEARCH_FORM_ONE_HAND_FOLDING,
    STROLLER_SEARCH_FORM_OTHER_BRANDS,
    STROLLER_SEARCH_FORM_POPULAR_BRANDS,
    STROLLER_SEARCH_FORM_PRICE_FROM,
    STROLLER_SEARCH_FORM_PRICE_TO,
    STROLLER_SEARCH_FORM_ROTATING_SEAT,
    STROLLER_SEARCH_FORM_SPACIOUS_CARRYCOT,
    STROLLER_SEARCH_FORM_SPACIOUS_SEAT,
    STROLLER_SEARCH_FORM_SUPPLIED_PAD,
    STROLLER_SEARCH_FORM_SWINGING,
    STROLLER_SEARCH_FORM_VERTICAL_SEAT,
    STROLLER_SEARCH_FORM_VERY_GOOD_FOLDING,
    STROLLER_SEARCH_FORM_WASHABLE_FABRICS,
    STROLLER_SEARCH_FORM_WEIGHT_IS_LOW,
    STROLLER_UNFOLDED_DIMENSIONS_IN_CM_WIDTH_MAX,
    STROLLER_UNFOLDED_DIMENSIONS_IN_CM_WIDTH_MIN,
    STROLLERS_SEARCH_FACET_BRAND,
    STROLLERS_SEARCH_FULLTEXT,
    STROLLERS_SEARCH_INVALID_NUMBER,
    STROLLERS_SEARCH_SHOW_MORE_FACETS,
} from 'mk/autogenerated/translations/StrollerSearchForm.7e149d2dc556ac6c743bebc88f4178fa'
import { canManageStrollers } from 'mk/bazaar/common/userUtils';
import { ACTIVE_SERVER_ID } from 'mk/settings';
import { CheckboxFieldWithCount } from 'mk2/apps/strollers/containers/StrollersSearch/CheckboxFieldWithCount';
import { CheckboxWithCount } from 'mk2/apps/strollers/containers/StrollersSearch/CheckboxWithCount';
import { FacetField } from 'mk2/apps/strollers/containers/StrollersSearch/FacetField';
import { FacetHelp } from 'mk2/apps/strollers/containers/StrollersSearch/FacetHelp';
import { RadioWithCount } from 'mk2/apps/strollers/containers/StrollersSearch/RadioWithCount';
import {
    strollersSearchLoadFacets,
    strollersSearchLoadHelp,
    SearchFacetsCounts,
} from 'mk2/apps/strollers/containers/StrollersSearch/StrollersSearch.actions';
import { STROLLERS_SEARCH_FORM_NAME } from 'mk2/apps/strollers/containers/StrollersSearch/StrollersSearch.constants';
import { getStrollersSearchState } from 'mk2/apps/strollers/containers/StrollersSearch/StrollersSearch.selectors';
import { FEATURES_LIST } from 'mk2/apps/strollers/features';
import { capitalizeFirstLetter } from 'mk2/apps/strollers/helpers';
import { ClickableField } from 'mk2/components/forms/ClickableField';
import { InputField } from 'mk2/components/forms/InputField';
import { Btn, BtnType } from 'mk2/components/Btn';
import { Form } from 'mk2/components/Form';
import { mkReduxForm, MKReduxFormInjectedProps } from 'mk2/decorators/mkReduxForm';
import { scrollDocumentTo } from 'mk2/helpers/scrolling';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { GetParams } from 'mk2/helpers/urls';
import { AppState } from 'mk2/reducers';
import { ContentItemEntity, ContentItemSchema } from 'mk2/schemas';
import { getDenormalizedEntities } from 'mk2/selectors';
import { interpolate } from 'mk2/services/i18n';
import { parse, stringify } from 'query-string';
import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { getFormValues, FormErrors } from 'redux-form';
import styles from './StrollerSearchForm.mscss';

export interface FacetOption {
    label: string;
    value: string;
    // Prepared for custom labels in the UI for SEO reasons
    seoLabel?: string;
}

export interface StrollerSearchFormData {
    // fulltext
    strollers_query: string;

    // multi selects
    type: string[];
    type_2kombi: string[];
    price: string[];
    color: string[];
    number_of_kids: string;
    siblings_type: string[];
    brand: string[];
    availability: string;
    variant_rear_wheel_type: string[];
    rotating_fixation_wheels: string[];
    stroller_for_parent_by_height: string[];
    number_of_wheels_l: string[];
    rear_wheels_diameter: string[];
    recommended_age: string[];
    maximum_load_per_child_in_kg_range: string[];
    back_support_can_be_in_lying_position: string[];

    // checkboxes
    back_support_can_be_in_vertical_seat_position: boolean;
    rotating_seat: boolean;
    swinging: boolean;
    spacious_carrycot: boolean;
    spacious_seat: boolean;
    weight_is_low: boolean;
    very_good_folding: boolean;
    big_shopping_basket: boolean;
    manual_brake_present: boolean;
    adjustable_handle: boolean;
    foldable_handrail: boolean;
    one_hand_folding: boolean;
    foldable_carrycot: boolean;
    carrycot_has_handle: boolean;
    back_support_can_be_positioned: boolean;
    leg_rest_can_be_positioned: boolean;
    car_seat_can_be_attached: boolean;
    supplied_pad: boolean;
    washable_fabrics: boolean;
    harness_type_5b: boolean;
    bumper_bar: boolean;

    priceFrom: string;
    priceTo: string;
    weight_in_kg_min: string;
    weight_in_kg_max: string;
    unfolded_dimensions_in_cm_width_min: string;
    unfolded_dimensions_in_cm_width_max: string;
    on_market_from_min: string;
    on_market_from_max: string;
}

const popularBrands = [
    'cybex',
    'britax',
    'bugaboo',
    'kinderkraft',
    'joolz',
    'thule',
    'easywalker',
    'maxi-cosi',
    'peg-perego',
    'petitemars',
    'abc-design',
    'baby-jogger',
    'hauck',
    'moon',
    'stokke',
    'zopa',
    'babystyle',
    'joie',
    'valco-baby',
    'espiro',
];

export type Facet =
    | 'type'
    | 'type_2kombi'
    | 'price'
    | 'number_of_kids'
    | 'siblings_type'
    | 'brand'
    | 'popular_brands'
    | 'other_brands'
    | 'availability'
    | 'variant_rear_wheel_type'
    | 'number_of_wheels_l'
    | 'rotating_fixation_wheels'
    | 'stroller_for_parent_by_height'
    | 'back_support_can_be_in_lying_position'
    | 'rear_wheels_diameter'
    | 'maximum_load_per_child_in_kg_range'
    | 'recommended_age';

export const facetLabels: Record<Facet, string> = {
    type: STROLLER_FEATURE_TYPE,
    type_2kombi: STROLLER_FEATURE_TYPE_2KOMBI,
    price: STROLLER_FEATURE_PRICE,
    number_of_kids: STROLLER_FEATURE_NUMBER_OF_KIDS,
    siblings_type: STROLLER_FEATURE_SIBLINGS_TYPE,
    popular_brands: STROLLER_SEARCH_FORM_POPULAR_BRANDS,
    other_brands: STROLLER_SEARCH_FORM_OTHER_BRANDS,
    brand: STROLLERS_SEARCH_FACET_BRAND,
    availability: STROLLER_FEATURE_AVAILABILITY,
    variant_rear_wheel_type: STROLLER_FEATURE_WHEEL_TYPE_SEARCH,
    rotating_fixation_wheels: STROLLER_FEATURE_ROTATING_FIXATION_WHEELS,
    stroller_for_parent_by_height: STROLLER_FEATURE_STROLLER_FOR_PARENT_BY_HEIGHT,
    back_support_can_be_in_lying_position: STROLLER_FEATURE_BACK_SUPPORT_CAN_BE_IN_LYING_POSITION,
    number_of_wheels_l: STROLLER_FEATURE_NUMBER_OF_WHEELS_L,
    rear_wheels_diameter: STROLLER_FEATURE_REAR_WHEELS_DIAMETER,
    recommended_age: STROLLER_FEATURE_RECOMMENDED_AGE,
    maximum_load_per_child_in_kg_range: STROLLER_SEARCH_FORM_MAXIMUM_LOAD_PER_CHILD_IN_KG,
};

export const facetOptions: Record<Facet, FacetOption[]> = {
    type: Object.keys(FEATURES_LIST.type.OPTIONS).filter(t => !FEATURES_LIST.type.HIDDEN_TYPES.includes(t)).map((type) => ({
        label: capitalizeFirstLetter(FEATURES_LIST.type.OPTIONS[type]),
        value: type,
    })),
    type_2kombi: Object.keys(FEATURES_LIST.type_2kombi.OPTIONS).map((type) => ({
        label: capitalizeFirstLetter(FEATURES_LIST.type_2kombi.OPTIONS[type]),
        value: type,
    })),
    price: [
        {
            label: STROLLER_FEATURE_PRICE_RANGE_1,
            value: ACTIVE_SERVER_ID === 201 ? '0-300' : '0-7500',
        },
        {
            label: STROLLER_FEATURE_PRICE_RANGE_2,
            value: ACTIVE_SERVER_ID === 201 ? '300-400' : '7500-10000',
        },
        {
            label: STROLLER_FEATURE_PRICE_RANGE_3,
            value: ACTIVE_SERVER_ID === 201 ? '400-500' : '10000-12500',
        },
        {
            label: STROLLER_FEATURE_PRICE_RANGE_4,
            value: ACTIVE_SERVER_ID === 201 ? '500-700' : '12500-17500',
        },
        {
            label: STROLLER_FEATURE_PRICE_RANGE_5,
            value: ACTIVE_SERVER_ID === 201 ? '700-1000' : '17500-25000',
        },
        {
            label: STROLLER_FEATURE_PRICE_RANGE_6,
            value: ACTIVE_SERVER_ID === 201 ? '1000-999999' : '25000-999999',
        },
    ],
    number_of_kids: Object.keys(FEATURES_LIST.number_of_kids.OPTIONS).map((type) => ({
        label: capitalizeFirstLetter(FEATURES_LIST.number_of_kids.OPTIONS[type]),
        value: type,
    })),
    siblings_type: Object.keys(FEATURES_LIST.siblings_type.OPTIONS).map((type) => ({
        label: capitalizeFirstLetter(FEATURES_LIST.siblings_type.OPTIONS[type]),
        value: type,
    })),
    popular_brands: popularBrands.map((slug) => {
        const brand = STROLLER_BRANDS.find((b) => b.slug === slug);
        return {
            label: capitalizeFirstLetter(brand.name),
            value: slug,
        };
    }),
    other_brands: STROLLER_BRANDS.filter((b) => !popularBrands.includes(b.slug)).map((brand) => ({
        label: capitalizeFirstLetter(brand.name),
        value: brand.slug,
    })),
    brand: STROLLER_BRANDS.map((brand) => ({
        label: capitalizeFirstLetter(brand.name),
        value: brand.slug,
    })),
    availability: [
        {
            label: STROLLER_FEATURE_AVAILABILITY_AVAILABLE,
            value: 'available',
        },
        {
            label: STROLLER_FEATURE_AVAILABILITY_ONLY_NEW,
            value: 'new',
        },
        {
            label: STROLLER_FEATURE_AVAILABILITY_ONLY_OLD,
            value: 'old',
        },
        {
            label: STROLLER_FEATURE_AVAILABILITY_ALL,
            value: 'all',
        },
    ],
    variant_rear_wheel_type: Object.keys(FEATURES_LIST.variant_rear_wheel_type.OPTIONS).map((type) => ({
        label: capitalizeFirstLetter(FEATURES_LIST.variant_rear_wheel_type.OPTIONS[type]),
        value: type,
    })),
    rotating_fixation_wheels: Object.keys(FEATURES_LIST.rotating_fixation_wheels.OPTIONS).map((type) => ({
        label: capitalizeFirstLetter(FEATURES_LIST.rotating_fixation_wheels.OPTIONS[type]),
        value: type,
    })),
    stroller_for_parent_by_height: Object.keys(FEATURES_LIST.stroller_for_parent_by_height.OPTIONS).map((type) => ({
        label: capitalizeFirstLetter(FEATURES_LIST.stroller_for_parent_by_height.OPTIONS[type]),
        value: type,
    })),
    back_support_can_be_in_lying_position: Object?.keys(FEATURES_LIST.back_support_can_be_in_lying_position.OPTIONS).slice(0, -1).map((type) => ({
        label: capitalizeFirstLetter(FEATURES_LIST.back_support_can_be_in_lying_position.OPTIONS[type]),
        value: type,
    })),
    number_of_wheels_l: [
        {
            label: '3',
            value: '3',
        },
        {
            label: '4',
            value: '4',
        },
    ],
    rear_wheels_diameter: [
        {
            label: STROLLER_FEATURE_REAR_WHEELS_DIAMETER_SMALL,
            value: 'small',
        },
        {
            label: STROLLER_FEATURE_REAR_WHEELS_DIAMETER_MEDIUM,
            value: 'medium',
        },
        {
            label: STROLLER_FEATURE_REAR_WHEELS_DIAMETER_BIG,
            value: 'big',
        },
    ],
    recommended_age: [
        { label: '0 - 6', value: '0_6' },
        { label: '6 - 12', value: '6_12' },
        { label: '12 - 18', value: '12_18' },
        { label: '18 - 24', value: '18_24' },
        { label: '24 - 30', value: '24_30' },
        { label: '30 - 36', value: '30_36' },
        { label: '36 - 42', value: '36_42' },
        { label: '42 - 48', value: '42_48' },
        { label: '48 - 54', value: '48_54' },
        { label: '54 - 60', value: '54_60' },
        { label: `60 ${STROLLER_FEATURE_RECOMMENDED_AGE_MORE_MONTHS}`, value: '60_9999' },
    ],
    maximum_load_per_child_in_kg_range: [
        { label: STROLLER_SEARCH_FORM_MAXIMUM_LOAD_PER_CHILD_IN_KG_RANGE_1, value: '0-15' },
        { label: STROLLER_SEARCH_FORM_MAXIMUM_LOAD_PER_CHILD_IN_KG_RANGE_2, value: '0-22' },
        { label: STROLLER_SEARCH_FORM_MAXIMUM_LOAD_PER_CHILD_IN_KG_RANGE_3, value: '22-99' },
    ],
};

export const checkboxFields: Record<
    | 'back_support_can_be_in_vertical_seat_position'
    | 'rotating_seat'
    | 'swinging'
    | 'spacious_carrycot'
    | 'spacious_seat'
    | 'weight_is_low'
    | 'very_good_folding'
    | 'big_shopping_basket'
    | 'manual_brake_present'
    | 'adjustable_handle'
    | 'foldable_handrail'
    | 'one_hand_folding'
    | 'foldable_carrycot'
    | 'carrycot_has_handle'
    | 'back_support_can_be_positioned'
    | 'leg_rest_can_be_positioned'
    | 'car_seat_can_be_attached'
    | 'supplied_pad'
    | 'washable_fabrics'
    | 'harness_type_5b'
    | 'bumper_bar',
    string
> = {
    back_support_can_be_in_vertical_seat_position: STROLLER_SEARCH_FORM_VERTICAL_SEAT,
    rotating_seat: STROLLER_SEARCH_FORM_ROTATING_SEAT,
    swinging: STROLLER_SEARCH_FORM_SWINGING,
    spacious_carrycot: STROLLER_SEARCH_FORM_SPACIOUS_CARRYCOT,
    spacious_seat: STROLLER_SEARCH_FORM_SPACIOUS_SEAT,
    weight_is_low: STROLLER_SEARCH_FORM_WEIGHT_IS_LOW,
    very_good_folding: STROLLER_SEARCH_FORM_VERY_GOOD_FOLDING,
    big_shopping_basket: STROLLER_SEARCH_FORM_BIG_SHOPPING_BASKET,
    manual_brake_present: STROLLER_SEARCH_FORM_MANUAL_BRAKE_PRESENT,
    adjustable_handle: STROLLER_SEARCH_FORM_ADJUSTABLE_HANDLE,
    foldable_handrail: STROLLER_SEARCH_FORM_FOLDABLE_HANDRAIL,
    one_hand_folding: STROLLER_SEARCH_FORM_ONE_HAND_FOLDING,
    foldable_carrycot: STROLLER_SEARCH_FORM_FOLDABLE_CARRYCOT,
    carrycot_has_handle: STROLLER_SEARCH_FORM_CARRYCOT_HAS_HANDLE,
    back_support_can_be_positioned: STROLLER_SEARCH_FORM_BACK_SUPPORT_CAN_BE_POSITIONED,
    leg_rest_can_be_positioned: STROLLER_SEARCH_FORM_LEG_REST_CAN_BE_POSITIONED,
    car_seat_can_be_attached: STROLLER_SEARCH_FORM_CAR_SEAT_CAN_BE_ATTACHED,
    supplied_pad: STROLLER_SEARCH_FORM_SUPPLIED_PAD,
    washable_fabrics: STROLLER_SEARCH_FORM_WASHABLE_FABRICS,
    harness_type_5b: STROLLER_SEARCH_FORM_HARNESS_TYPE_5B,
    bumper_bar: STROLLER_SEARCH_FORM_BUMPER_BAR,
};

function qsAsArray(qsValue: string | string[]): string[] {
    if (!qsValue) {
        return [];
    }
    return Array.isArray(qsValue) ? qsValue : [qsValue];
}
function qsAsString(qsValue: string | string[]): string {
    if (!qsValue) {
        return '';
    }
    return Array.isArray(qsValue) ? qsValue?.[qsValue.length - 1] : qsValue;
}
function qsAsBoolean(qsValue: string | string[]): boolean {
    return qsAsString(qsValue) === 'true';
}

export function serializeToQS(formData: StrollerSearchFormData): GetParams {

    return {
        ...formData,
        // Convert empty strings or 'false' values to undefined to remove them from the query string
        strollers_query: formData.strollers_query || undefined,
        back_support_can_be_in_vertical_seat_position: formData.back_support_can_be_in_vertical_seat_position || undefined,
        rotating_seat: formData.rotating_seat || undefined,
        number_of_kids: formData.number_of_kids || undefined,
        swinging: formData.swinging || undefined,
        spacious_carrycot: formData.spacious_carrycot || undefined,
        spacious_seat: formData.spacious_seat || undefined,
        weight_is_low: formData.weight_is_low || undefined,
        very_good_folding: formData.very_good_folding || undefined,
        big_shopping_basket: formData.big_shopping_basket || undefined,
        manual_brake_present: formData.manual_brake_present || undefined,
        adjustable_handle: formData.adjustable_handle || undefined,
        foldable_handrail: formData.foldable_handrail || undefined,
        one_hand_folding: formData.one_hand_folding || undefined,
        foldable_carrycot: formData.foldable_carrycot || undefined,
        carrycot_has_handle: formData.carrycot_has_handle || undefined,
        back_support_can_be_positioned: formData.back_support_can_be_positioned || undefined,
        leg_rest_can_be_positioned: formData.leg_rest_can_be_positioned || undefined,
        back_support_can_be_in_lying_position: formData.back_support_can_be_in_lying_position || undefined,
        car_seat_can_be_attached: formData.car_seat_can_be_attached || undefined,
        supplied_pad: formData.supplied_pad || undefined,
        washable_fabrics: formData.washable_fabrics || undefined,
        harness_type_5b: formData.harness_type_5b || undefined,
        bumper_bar: formData.bumper_bar || undefined,
        priceTo: formData.priceTo || undefined,
        priceFrom: formData.priceFrom || undefined,
        weight_in_kg_min: formData.weight_in_kg_min || undefined,
        weight_in_kg_max: formData.weight_in_kg_max || undefined,
        unfolded_dimensions_in_cm_width_min: formData.unfolded_dimensions_in_cm_width_min || undefined,
        unfolded_dimensions_in_cm_width_max: formData.unfolded_dimensions_in_cm_width_max || undefined,
        on_market_from_min: formData.on_market_from_min || undefined,
        on_market_from_max: formData.on_market_from_max || undefined,
        color: formData.color || undefined,
    };
}

export function deserializeFromUrl(locationSearch: string, requestUserPermissions: string[]): StrollerSearchFormData {
    const qs = parse(locationSearch);

    return {
        strollers_query: (qs.strollers_query as string) ?? '',

        type: qsAsArray(qs.type),
        type_2kombi: qsAsArray(qs.type_2kombi),
        price: qsAsArray(qs.price),
        color: qsAsArray(qs.color),
        number_of_kids: qsAsString(qs.number_of_kids),
        siblings_type: qsAsArray(qs.siblings_type),
        brand: qsAsArray(qs.brand),
        availability: qsAsString(qs.availability) || (
            canManageStrollers(requestUserPermissions) ? 'all' : 'available'
        ),
        variant_rear_wheel_type: qsAsArray(qs.variant_rear_wheel_type),
        rotating_fixation_wheels: qsAsArray(qs.rotating_fixation_wheels),
        stroller_for_parent_by_height: qsAsArray(qs.stroller_for_parent_by_height),
        number_of_wheels_l: qsAsArray(qs.number_of_wheels_l),
        rear_wheels_diameter: qsAsArray(qs.rear_wheels_diameter),
        recommended_age: qsAsArray(qs.recommended_age),
        maximum_load_per_child_in_kg_range: qsAsArray(qs.maximum_load_per_child_in_kg_range),
        back_support_can_be_in_lying_position: qsAsArray(qs.back_support_can_be_in_lying_position),

        back_support_can_be_in_vertical_seat_position: qsAsBoolean(qs.back_support_can_be_in_vertical_seat_position),
        rotating_seat: qsAsBoolean(qs.rotating_seat),
        swinging: qsAsBoolean(qs.swinging),
        spacious_carrycot: qsAsBoolean(qs.spacious_carrycot),
        spacious_seat: qsAsBoolean(qs.spacious_seat),
        weight_is_low: qsAsBoolean(qs.weight_is_low),
        very_good_folding: qsAsBoolean(qs.very_good_folding),
        big_shopping_basket: qsAsBoolean(qs.big_shopping_basket),
        manual_brake_present: qsAsBoolean(qs.manual_brake_present),
        adjustable_handle: qsAsBoolean(qs.adjustable_handle),
        foldable_handrail: qsAsBoolean(qs.foldable_handrail),
        one_hand_folding: qsAsBoolean(qs.one_hand_folding),
        foldable_carrycot: qsAsBoolean(qs.foldable_carrycot),
        carrycot_has_handle: qsAsBoolean(qs.carrycot_has_handle),
        back_support_can_be_positioned: qsAsBoolean(qs.back_support_can_be_positioned),
        leg_rest_can_be_positioned: qsAsBoolean(qs.leg_rest_can_be_positioned),
        car_seat_can_be_attached: qsAsBoolean(qs.car_seat_can_be_attached),
        supplied_pad: qsAsBoolean(qs.supplied_pad),
        washable_fabrics: qsAsBoolean(qs.washable_fabrics),
        harness_type_5b: qsAsBoolean(qs.harness_type_5b),
        bumper_bar: qsAsBoolean(qs.bumper_bar),

        priceFrom: qsAsString(qs.priceFrom),
        priceTo: qsAsString(qs.priceTo),
        weight_in_kg_min: qsAsString(qs.weight_in_kg_min),
        weight_in_kg_max: qsAsString(qs.weight_in_kg_max),
        unfolded_dimensions_in_cm_width_min: qsAsString(qs.unfolded_dimensions_in_cm_width_min),
        unfolded_dimensions_in_cm_width_max: qsAsString(qs.unfolded_dimensions_in_cm_width_max),
        on_market_from_min: qsAsString(qs.on_market_from_min),
        on_market_from_max: qsAsString(qs.on_market_from_max),
    };
}

const toFloat = (v: string) => parseFloat(v.replace(',', '.'));
const toInt = (v: string) => parseInt(v, 10);


const validate = (values: StrollerSearchFormData) => {
    const errors: FormErrors<StrollerSearchFormData> = {};
    if (values.weight_in_kg_max) {
        if (isNaN(toFloat(values.weight_in_kg_max))) {
            errors.weight_in_kg_max = STROLLERS_SEARCH_INVALID_NUMBER;
        }
    }
    if (values.weight_in_kg_min) {
        if (isNaN(toFloat(values.weight_in_kg_min))) {
            errors.weight_in_kg_min = STROLLERS_SEARCH_INVALID_NUMBER;
        }
    }
    if (values.weight_in_kg_max && values.weight_in_kg_min) {
        if (toFloat(values.weight_in_kg_min) > toFloat(values.weight_in_kg_max)) {
            errors.weight_in_kg_max = STROLLERS_SEARCH_INVALID_NUMBER;
        }
    }
    if (values.priceFrom) {
        if (isNaN(toFloat(values.priceFrom))) {
            errors.priceFrom = STROLLERS_SEARCH_INVALID_NUMBER;
        }
    }
    if (values.priceTo) {
        if (isNaN(toFloat(values.priceTo))) {
            errors.priceTo = STROLLERS_SEARCH_INVALID_NUMBER;
        }
    }
    if (values.priceFrom && values.priceTo) {
        if (toFloat(values.priceFrom) > toFloat(values.priceTo)) {
            errors.priceTo = STROLLERS_SEARCH_INVALID_NUMBER;
        }
    }
    if (values.unfolded_dimensions_in_cm_width_min) {
        if (isNaN(toFloat(values.unfolded_dimensions_in_cm_width_min))) {
            errors.unfolded_dimensions_in_cm_width_min = STROLLERS_SEARCH_INVALID_NUMBER;
        }
    }
    if (values.unfolded_dimensions_in_cm_width_max) {
        if (isNaN(toFloat(values.unfolded_dimensions_in_cm_width_max))) {
            errors.unfolded_dimensions_in_cm_width_max = STROLLERS_SEARCH_INVALID_NUMBER;
        }
    }
    if (values.unfolded_dimensions_in_cm_width_min && values.unfolded_dimensions_in_cm_width_max) {
        if (toFloat(values.unfolded_dimensions_in_cm_width_min) > toFloat(values.unfolded_dimensions_in_cm_width_max)) {
            errors.unfolded_dimensions_in_cm_width_max = STROLLERS_SEARCH_INVALID_NUMBER;
        }
    }
    if (values.on_market_from_min) {
        if (isNaN(toInt(values.on_market_from_min))) {
            errors.on_market_from_min = STROLLERS_SEARCH_INVALID_NUMBER;
        }
    }
    if (values.on_market_from_max) {
        if (isNaN(toInt(values.on_market_from_max))) {
            errors.on_market_from_max = STROLLERS_SEARCH_INVALID_NUMBER;
        }
    }
    if (values.on_market_from_min && values.on_market_from_max) {
        if (toInt(values.on_market_from_min) > toInt(values.on_market_from_max)) {
            errors.on_market_from_max = STROLLERS_SEARCH_INVALID_NUMBER;
        }
    }
    return errors;
};

interface OwnProps {
    initialValues: StrollerSearchFormData;
    showAdditionalFacets: boolean;

    onToggleMoreFacets();
    onSave(values: StrollerSearchFormData);
}

interface StateProps {
    helpTexts: ContentItemEntity[];
    currentValues: StrollerSearchFormData;
    searchFacetsCounts: SearchFacetsCounts;
}

interface DispatchProps {
    onLoadFacets(values: StrollerSearchFormData);
    onLoadHelp();
}

type Props = OwnProps & StateProps & DispatchProps;

interface State {
    opened: string[];
}

class StrollerSearchFormComponent extends React.Component<
    Props & MKReduxFormInjectedProps<StrollerSearchFormData, Props>,
    State
> {
    public state: State = {
        opened: [],
    };

    public componentDidMount() {
        // If facet counts are not loaded - load them async
        if (!this.props.searchFacetsCounts) {
            this.props.onLoadFacets(this.props.initialValues);
        }

        if (!this.props.helpTexts.length) {
            this.props.onLoadHelp();
        }
    }

    public componentDidUpdate(prevProps: Props) {
        const { currentValues, onLoadFacets } = this.props;
        if (
            stringify(serializeToQS(prevProps.currentValues)) !==
            stringify(serializeToQS(currentValues))
        ) {
            onLoadFacets(currentValues);
        }
    }

    public render() {
        const {
            handleSubmit,
            onToggleMoreFacets,
            showAdditionalFacets,
            currentValues,
            searchFacetsCounts,
            helpTexts,
        } = this.props;

        const helpTextsByKey = helpTexts.reduce((acc, item) => {
            acc[item.key] = item;
            return acc;
        }, {});

        const colorsInfo = prams.p_color.map((p, index) => ({
                    label: p[1],
                    filterValue: p[1],
                    value: p[0],
                    count: (index + 1) * 5,
                })).filter((p) => !(p.value === 'TRANSPARENT' || 'BLACK_AND_WHITE' === p.value));

        return (
            <Form className={styles.StrollerSearchForm} onSubmit={handleSubmit}>
                <InputField name="strollers_query" type="text" label={STROLLERS_SEARCH_FULLTEXT} />

                <FacetField
                    name="type"
                    label={facetLabels.type}
                    onToggle={this.onFacetToggle}
                    opened={this.state.opened.includes('type')}
                    options={facetOptions.type}
                    selected={currentValues.type}
                    onChange={this.onFacetChange}
                    counts={searchFacetsCounts?.type}
                    help={helpTextsByKey['stroller-search-form-help-type']}
                />

                {currentValues.type.some((v) => v === '2kombi') && (
                    <FacetField
                        name="type_2kombi"
                        label={facetLabels.type_2kombi}
                        onToggle={this.onFacetToggle}
                        opened={this.state.opened.includes('type_2kombi')}
                        options={facetOptions.type_2kombi}
                        selected={currentValues.type_2kombi}
                        onChange={this.onFacetChange}
                        counts={searchFacetsCounts?.type_2kombi}
                        help={helpTextsByKey['stroller-search-form-help-type-2kombi']}
                    />
                )}

                <FacetField
                    name="price"
                    label={facetLabels.price}
                    onToggle={this.onFacetToggle}
                    opened={this.state.opened.includes('price')}
                    options={facetOptions.price}
                    selected={currentValues.price}
                    onChange={this.onFacetChange}
                    counts={searchFacetsCounts?.price}
                    additionalValue={
                        (!!currentValues.priceFrom || !!currentValues.priceTo) &&
                        interpolate(STROLLER_FEATURE_PRICE_RANGE_from_to, {
                            from: currentValues.priceFrom || 0,
                            to: currentValues.priceTo || 999999,
                        })
                    }
                    help={helpTextsByKey['stroller-search-form-help-price']}
                >
                    <div className={styles.StrollerSearchForm__price__fields}>
                        <div className={styles.StrollerSearchForm__price__fields__field}>
                            <InputField name="priceFrom" type="text" label={STROLLER_SEARCH_FORM_PRICE_FROM} />
                        </div>
                        <div className={styles.StrollerSearchForm__price__fields__field}>
                            <InputField name="priceTo" type="text" label={STROLLER_SEARCH_FORM_PRICE_TO} />
                        </div>
                    </div>
                </FacetField>

                <FacetField
                    name="color"
                    label={BZ2_FACET_P_COLOR}
                    onToggle={this.onFacetToggle}
                    opened={this.state.opened.includes('color')}
                    options={colorsInfo}
                    selected={currentValues.color}
                    onChange={this.onFacetChange}
                    counts={searchFacetsCounts?.color}
                />
                <ClickableField
                    name="number_of_kids"
                    label={facetLabels.number_of_kids}
                    onClick={this.onNumberOfKidsToggle}
                    ValueComponent={(
                        { value }, // tslint:disable-line:jsx-no-lambda
                    ) => (
                        <span className={styles.StrollerSearchForm__value}>
                            {facetOptions.number_of_kids.find((o) => o.value === value)?.label}
                        </span>
                    )}
                    arrowIcon={this.state.opened.includes('number_of_kids') ? faAngleUp : faAngleDown}
                />
                {this.state.opened.includes('number_of_kids') && (
                    <div className={styles.StrollerSearchForm__options}>
                        {facetOptions.number_of_kids.map((opt) => (
                            <RadioWithCount
                                key={opt.value}
                                name="number_of_kids"
                                label={opt.label}
                                value={opt.value}
                                checked={currentValues.number_of_kids === opt.value}
                                onChange={this.onFacetChange}
                                count={searchFacetsCounts?.number_of_kids?.[opt.value]}
                            />
                        ))}

                        {helpTextsByKey['stroller-search-form-help-availability'] && (
                            <FacetHelp help={helpTextsByKey['stroller-search-form-help-availability']} />
                        )}
                    </div>
                )}

                {currentValues.number_of_kids === 'more' && (
                    <FacetField
                        name="siblings_type"
                        label={facetLabels.siblings_type}
                        onToggle={this.onFacetToggle}
                        opened={this.state.opened.includes('siblings_type')}
                        options={facetOptions.siblings_type}
                        selected={currentValues.siblings_type}
                        onChange={this.onFacetChange}
                        counts={searchFacetsCounts?.siblings_type}
                        help={helpTextsByKey['stroller-search-form-help-siblings-type']}
                    />
                )}

                <ClickableField
                    name="brand"
                    label={facetLabels.brand}
                    onClick={this.onBrandsToggle}
                    ValueComponent={(
                        { value }, // tslint:disable-line:jsx-no-lambda
                    ) => {
                        const selectedOptions = value
                            .map((v) =>
                                [...facetOptions.popular_brands, ...facetOptions.other_brands].find(
                                    (o) => o.value === v,
                                ),
                            )
                            .filter(Boolean);
                        return (
                            <span className={styles.StrollerSearchForm__value}>
                                {selectedOptions.map((o, i) => (
                                    <React.Fragment key={o.value}>
                                        {o.label}
                                        {i < selectedOptions.length - 1 && ', '}
                                    </React.Fragment>
                                ))}
                            </span>
                        );
                    }}
                    arrowIcon={this.state.opened.includes('brand') ? faAngleUp : faAngleDown}
                />
                {this.state.opened.includes('brand') && (
                    <div className={styles.StrollerSearchForm__options}>
                        <div className={styles.StrollerSearchForm__options__group}>
                            {STROLLER_SEARCH_FORM_POPULAR_BRANDS}
                        </div>
                        <div className={styles.StrollerSearchForm__options__brands}>
                            {facetOptions.popular_brands.map((opt) => (
                                <CheckboxWithCount
                                    className={styles.StrollerSearchForm__options__brands__brand}
                                    key={opt.value}
                                    name="brand"
                                    label={opt.label}
                                    value={opt.value}
                                    checked={currentValues.brand.includes(opt.value)}
                                    onChange={this.onFacetChange}
                                    count={searchFacetsCounts?.brand_slug?.[opt.value]}
                                />
                            ))}
                        </div>
                        <div className={styles.StrollerSearchForm__options__group}>
                            {STROLLER_SEARCH_FORM_OTHER_BRANDS}
                        </div>
                        <div className={styles.StrollerSearchForm__options__brands}>
                            {facetOptions.other_brands.map((opt) => (
                                <CheckboxWithCount
                                    className={styles.StrollerSearchForm__options__brands__brand}
                                    key={opt.value}
                                    name="brand"
                                    label={opt.label}
                                    value={opt.value}
                                    checked={currentValues.brand.includes(opt.value)}
                                    onChange={this.onFacetChange}
                                    count={searchFacetsCounts?.brand_slug?.[opt.value]}
                                />
                            ))}
                        </div>

                        {helpTextsByKey['stroller-search-form-help-brand'] && (
                            <FacetHelp help={helpTextsByKey['stroller-search-form-help-brand']} />
                        )}
                    </div>
                )}

                <ClickableField
                    name="availability"
                    label={facetLabels.availability}
                    onClick={this.onAvailabilityToggle}
                    ValueComponent={(
                        { value }, // tslint:disable-line:jsx-no-lambda
                    ) => (
                        <span className={styles.StrollerSearchForm__value}>
                            {facetOptions.availability.find((o) => o.value === value)?.label}
                        </span>
                    )}
                    arrowIcon={this.state.opened.includes('availability') ? faAngleUp : faAngleDown}
                />
                {this.state.opened.includes('availability') && (
                    <div className={styles.StrollerSearchForm__options}>
                        {facetOptions.availability.map((opt) => (
                            <RadioWithCount
                                key={opt.value}
                                name="availability"
                                label={opt.label}
                                value={opt.value}
                                checked={currentValues.availability === opt.value}
                                onChange={this.onFacetChange}
                                count={searchFacetsCounts?.availability?.[opt.value]}
                            />
                        ))}

                        {helpTextsByKey['stroller-search-form-help-availability'] && (
                            <FacetHelp help={helpTextsByKey['stroller-search-form-help-availability']} />
                        )}
                    </div>
                )}

                <FacetField
                    name="variant_rear_wheel_type"
                    label={facetLabels.variant_rear_wheel_type}
                    onToggle={this.onFacetToggle}
                    opened={this.state.opened.includes('variant_rear_wheel_type')}
                    options={facetOptions.variant_rear_wheel_type}
                    selected={currentValues.variant_rear_wheel_type}
                    onChange={this.onFacetChange}
                    counts={searchFacetsCounts?.variant_rear_wheel_type}
                    help={helpTextsByKey['stroller-search-form-help-variant-rear-wheel-type']}
                />

                <FacetField
                    name="rotating_fixation_wheels"
                    label={facetLabels.rotating_fixation_wheels}
                    onToggle={this.onFacetToggle}
                    opened={this.state.opened.includes('rotating_fixation_wheels')}
                    options={facetOptions.rotating_fixation_wheels}
                    selected={currentValues.rotating_fixation_wheels}
                    onChange={this.onFacetChange}
                    counts={searchFacetsCounts?.rotating_fixation_wheels}
                    help={helpTextsByKey['stroller-search-form-help-rotating-fixation-wheels']}
                />

                <FacetField
                    name="stroller_for_parent_by_height"
                    label={facetLabels.stroller_for_parent_by_height}
                    onToggle={this.onFacetToggle}
                    opened={this.state.opened.includes('stroller_for_parent_by_height')}
                    options={facetOptions.stroller_for_parent_by_height}
                    selected={currentValues.stroller_for_parent_by_height}
                    onChange={this.onFacetChange}
                    counts={searchFacetsCounts?.stroller_for_parent_by_height}
                    help={helpTextsByKey['stroller-search-form-help-parent-height']}
                />

                <FacetField
                    name="back_support_can_be_in_lying_position"
                    label={facetLabels.back_support_can_be_in_lying_position}
                    onToggle={this.onFacetToggle}
                    opened={this.state.opened.includes('back_support_can_be_in_lying_position')}
                    options={facetOptions.back_support_can_be_in_lying_position}
                    selected={currentValues.back_support_can_be_in_lying_position}
                    onChange={this.onFacetChange}
                    counts={searchFacetsCounts?.back_support_can_be_in_lying_position}
                />

                {Object.keys(checkboxFields).map(
                    (name, i) =>
                        (showAdditionalFacets || i < 8) && (
                            <CheckboxFieldWithCount
                                key={name}
                                name={name}
                                label={checkboxFields[name]}
                                count={
                                    name === 'harness_type_5b'
                                        ? searchFacetsCounts?.harness_type['5b']
                                        : searchFacetsCounts?.[name]?.true
                                }
                                help={helpTextsByKey[`stroller-search-form-help-${name.replace(/_/g, '-')}`]}
                            />
                        ),
                )}

                {!showAdditionalFacets ? (
                    <div className={styles.StrollerSearchForm__showAdditionalFacets}>
                        <Btn
                            label={STROLLERS_SEARCH_SHOW_MORE_FACETS}
                            onClick={onToggleMoreFacets}
                            type={BtnType.BlueTextLight}
                        />
                    </div>
                ) : (
                    <>
                        <FacetField
                            name="number_of_wheels_l"
                            label={facetLabels.number_of_wheels_l}
                            onToggle={this.onFacetToggle}
                            opened={this.state.opened.includes('number_of_wheels_l')}
                            options={facetOptions.number_of_wheels_l}
                            selected={currentValues.number_of_wheels_l}
                            onChange={this.onFacetChange}
                            counts={searchFacetsCounts?.number_of_wheels_l}
                            help={helpTextsByKey['stroller-search-form-help-number-of-wheels-l']}
                        />

                        <FacetField
                            name="rear_wheels_diameter"
                            label={facetLabels.rear_wheels_diameter}
                            onToggle={this.onFacetToggle}
                            opened={this.state.opened.includes('rear_wheels_diameter')}
                            options={facetOptions.rear_wheels_diameter}
                            selected={currentValues.rear_wheels_diameter}
                            onChange={this.onFacetChange}
                            counts={searchFacetsCounts?.rear_wheels_diameter}
                            help={helpTextsByKey['stroller-search-form-help-rear-wheels-diameter']}
                        />

                        <FacetField
                            name="recommended_age"
                            label={facetLabels.recommended_age}
                            onToggle={this.onFacetToggle}
                            opened={this.state.opened.includes('recommended_age')}
                            options={facetOptions.recommended_age}
                            selected={currentValues.recommended_age}
                            onChange={this.onFacetChange}
                            counts={searchFacetsCounts?.recommended_age}
                            help={helpTextsByKey['stroller-search-form-help-recommended-age']}
                        />

                        <FacetField
                            name="maximum_load_per_child_in_kg_range"
                            label={facetLabels.maximum_load_per_child_in_kg_range}
                            onToggle={this.onFacetToggle}
                            opened={this.state.opened.includes('maximum_load_per_child_in_kg_range')}
                            options={facetOptions.maximum_load_per_child_in_kg_range}
                            selected={currentValues.maximum_load_per_child_in_kg_range}
                            onChange={this.onFacetChange}
                            counts={searchFacetsCounts?.maximum_load_per_child_in_kg_range}
                            help={helpTextsByKey['stroller-search-form-help-maximum-load-per-child-in-kg-range']}
                        />

                        <div className={styles.StrollerSearchForm__weight}>
                            <div className={styles.StrollerSearchForm__weight__field}>
                                <InputField
                                    name="weight_in_kg_min"
                                    type="text"
                                    label={STROLLER_FEATURE_WEIGHT_IN_KG_MIN}
                                />
                            </div>
                            <div className={styles.StrollerSearchForm__weight__field}>
                                <InputField
                                    name="weight_in_kg_max"
                                    type="text"
                                    label={STROLLER_FEATURE_WEIGHT_IN_KG_MAX}
                                />
                            </div>
                        </div>

                        <div className={styles.StrollerSearchForm__width}>
                            <div className={styles.StrollerSearchForm__width__field}>
                                <InputField
                                    name="unfolded_dimensions_in_cm_width_min"
                                    type="text"
                                    label={STROLLER_UNFOLDED_DIMENSIONS_IN_CM_WIDTH_MIN}
                                />
                            </div>
                            <div className={styles.StrollerSearchForm__width__field}>
                                <InputField
                                    name="unfolded_dimensions_in_cm_width_max"
                                    type="text"
                                    label={STROLLER_UNFOLDED_DIMENSIONS_IN_CM_WIDTH_MAX}
                                />
                            </div>
                        </div>

                        <div className={styles.StrollerSearchForm__market}>
                            <div className={styles.StrollerSearchForm__market__field}>
                                <InputField
                                    name="on_market_from_min"
                                    type="text"
                                    label={STROLLER_FEATURE_ON_MARKET_FROM_MIN}
                                />
                            </div>
                            <div className={styles.StrollerSearchForm__market__field}>
                                <InputField
                                    name="on_market_from_max"
                                    type="text"
                                    label={STROLLER_FEATURE_ON_MARKET_FROM_MAX}
                                />
                            </div>
                        </div>
                    </>
                )}
            </Form>
        );
    }

    private onFacetToggle = (facetName: string) => {
        this.setState({
            opened: this.state.opened.includes(facetName)
                ? this.state.opened.filter((f) => f !== facetName)
                : [...this.state.opened, facetName],
        });
    };

    private onBrandsToggle = () => this.onFacetToggle('brand');
    private onAvailabilityToggle = () => this.onFacetToggle('availability');
    private onNumberOfKidsToggle = () => this.onFacetToggle('number_of_kids');

    private onFacetChange = (facetName: string, facetValue: string | boolean) => {
        const { change, currentValues } = this.props;
        if (facetName === 'availability') {
            change('availability', facetValue);
        } else if (facetName === 'type') {
            const isSelected = currentValues.type.some((v) => v === facetValue);
            const newValue = isSelected
                ? currentValues.type.filter((v) => v !== facetValue)
                : [...currentValues.type, facetValue];
            change('type', newValue);
            if (!newValue.includes('siblings')) {
                change('siblings_type', []);
            }
            if (!newValue.includes('2kombi')) {
                change('type_2kombi', []);
            }
        } else if (Array.isArray(currentValues[facetName])) {
            const isSelected = currentValues[facetName].some((v) => v === facetValue);
            const newValue = isSelected
                ? currentValues[facetName].filter((v) => v !== facetValue)
                : [...currentValues[facetName], facetValue];
            change(facetName, newValue);
        } else {
            change(facetName, facetValue);
        }
    };
}

const formSelector = getFormValues(STROLLERS_SEARCH_FORM_NAME);
function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    const currentValues = formSelector(state) as StrollerSearchFormData || ownProps.initialValues;
    const searchFacetsCounts = currentValues
        ? getStrollersSearchState(state).searchFacetsCounts[stringify(serializeToQS(currentValues))]?.counts
        : null;
    const strollersSearchState = getStrollersSearchState(state);
    return {
        currentValues,
        helpTexts: getDenormalizedEntities<ContentItemEntity>(state, ContentItemSchema, strollersSearchState.helpTexts),
        searchFacetsCounts,
    };
}
const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onLoadFacets: strollersSearchLoadFacets,
    onLoadHelp: strollersSearchLoadHelp,
};
const ConnectedStrollerSearchForm = connect(mapStateToProps, mapDispatchToProps)(StrollerSearchFormComponent);

export const StrollerSearchForm = mkReduxForm<StrollerSearchFormData, OwnProps>({
    formName: STROLLERS_SEARCH_FORM_NAME,
    onValidate: validate,
    onSave: async (values, props) => {
        scrollDocumentTo('top');
        await props.onSave(values);
    },
})(ConnectedStrollerSearchForm);
